import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';

import {vendorCodes} from 'modules/store/vendors';

import {invalidateAccounts} from 'modules/store/accounts';
import {TIMEOUT_STORE} from 'util/constants';

const
    mapFields = {
        cloud_account_id: 'cloudAccountId'
    },
    transformEntitiesFn = account => {
        if (typeof account !== 'object') {
            throw new Error('transformAlicloud needs an object to transform');
        }

        return {
            id:        account.id,
            name:      account.alias,
            reselling: account.reselling,
            vendor:    {
                selected: vendorCodes.alicloud,
                values:   {
                    cloudAccountId: account.cloud_account_id
                }
            }
        };

    },
    transformEntitiesToSaveFn = account => Object.keys(account.vendor)
        .reduce((ret, key) => ({
            ...ret,
            cloud_account_id: account.vendor.cloudAccountId
        }), {
            name: account.name
        });

const exports = storeModuleFactory({
    name:             'alicloudAccounts',
    endpoint:         endpoints.accounts.alicloud.endpoint,
    instanceEndpoint: endpoints.accounts.alicloud.instanceEndpoint,
    callbackActions:  [{
        method: 'update',
        action: invalidateAccounts
    }],
    timeout: TIMEOUT_STORE.TIMEOUT_STORE_MEDIUM,
    transformEntitiesFn,
    transformEntitiesToSaveFn
});

exports.transformEntitiesFn = transformEntitiesFn;
exports.transformEntitiesToSaveFn = transformEntitiesToSaveFn;
exports.mapFields = mapFields;

module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/alicloudAccounts.js